/* DESARROLLO GENERADOR CONTRATOS VERSION 2.0 
09.OCT.2024 
LOB -> LINE OF BUSINESS lineas de ngocio */
import api from './api';
import ErrorService from './errorService';
import { getConsultantIdentifier } from '../Redux/consultantUtils';
import { ApiService } from './apiService';

export const LobService = {
    
    SearchCronologia: async (Id) => {
        //const contractId = 60
        try {
            const response = await ErrorService.withTimeout(api.get(`/Cronologia/${Id}`));
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },
    
    getSearchInterview: async (data) => {
        try {
            const response = await ErrorService.withTimeout(
                api.post(`/SearchInterView/List`,  data )
            );
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },

      getSearchInterviewV2: async (data) => {
        try {
            const response = await ErrorService.withTimeout(
                api.post(`/SearchInterView/ListV2`,  data )
            );
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },  

    getSearchInterviewExcel: async (data) => {
        try {
            const response = await ErrorService.withTimeout(
                api.post(`/SearchInterView/ListExcel`, data )
            );
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },

     getSearchInterviewExcelV2: async (data) => {
        try {
            const response = await ErrorService.withTimeout(
                api.post(`/SearchInterView/ListExcelV2`, data )
            );
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },   

    getContractID: async (contratoId) => {
        //const contractId = 60
        try {
            const response = await ErrorService.withTimeout(api.get(`/Contract/${contratoId}`));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },

    getContractBy: async (rut, NumContrato) => {
        try {
            const response = await ErrorService.withTimeout(api.get(`/Contract/${rut}/${NumContrato}`));

            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },

    CheckContractData: async (NumContrato) => {
        try {
            const response = await ErrorService.withTimeout(api.get(`/Cuotas?NumContrato=${NumContrato}`));
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },

    CheckFirmasContrato: async (identifier, numContrato, contractId) => {
        const CreateBy = getConsultantIdentifier();
        if (!CreateBy) {
            throw new Error('No se pudo obtener el identificador del consultor');
        }

        try {
            const response = await ErrorService.withTimeout(api.post('/Contract/CheckFirmasContrato', { identifier, numContrato, contractId, CreateBy }));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },
      
    getCustomerContract: async (identifier, NumContrato) => {
        try {
            const response = await ErrorService.withTimeout(
                api.get(`/Contract/GetCustomerContract`, {
                    params: { identifier, NumContrato }
                })
            );
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },
    getTemplateContratos: async (idBusiness, type) => { //<-  templates de contratos (layout)
        try {
            const response = await ErrorService.withTimeout(api.get(`/Contract/ContractsByLineOfBusiness?lineOfBusinessId=${idBusiness}&type=${type}`));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },
    SaveHtmlContrat: async (data) => {
        try {
            const response = await ErrorService.withTimeout(api.post('/Contract/SaveHtmlContrat', data));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos del contrato:', error);
            throw error;
        }
    },

    getMetodosPago: async () => {
        try {
            const response = await ErrorService.withTimeout(api.get('/MetodoPago'));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener MetodoPago:', error);
            throw error;
        }
    },

    getCuotasContrato: async (contratoId, identifier) => {
        //  const contractId = 88
        //const identifier = '12543986-7'
        try {
            const response = await ErrorService.withTimeout(api.get(`/Cuotas/${identifier}/${contratoId}`));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener cuotas del contrato:', error);
            throw error;
        }
    },

    //GUARDA LAS CUOTAS DEL CONTRATO 
    saveContractData: async (contractData) => {
        const consultantIdentifier = getConsultantIdentifier();
        if (!consultantIdentifier) {
            throw new Error('No se pudo obtener el identificador del consultor');
        }
        try {
            const payload = {
                contractId: contractData.contract.contratoId,
                identifier: contractData.contract.identifier,
                numContrato: contractData.contract.numContrato,
                createdBy: consultantIdentifier,
                payingCustomerId: contractData.payingCustomerId,
                lineaDeNegocio: contractData.linesOfBusiness.map(line => ({
                    montoRestar: line.montoRestar??0,
                    lineaId: line.idBusiness,
                    fechaPrimerPago: line.firstPaymentDate,
                    metodoPagoId: line.paymentMethod,
                    numeroCuotas: parseInt(line.numberOfInstallments),
                    cuotas: line.installments.map(installment => ({
                        monto: parseFloat(installment.amount),
                        fechaCuota: installment.date,
                        numeroCuota: installment.number
                    }))
                }))
            };

            const response = await ErrorService.withTimeout(api.post('/Cuotas', payload));
            return response.data;
        } catch (error) {
            ErrorService.handleApiError(error);
            throw error;
        }
    },

    // METODOS DE MANTENEDOR
    getAllLineOfBusiness: async () => {
        try {
            const response = ApiService.get('/LineOfBusiness');
            return response;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener las lineas de negocios:', error);
            throw error;
        }
    },

    getLineOfBusinessById: async (id) => {
        try {
            const response = await ApiService.get(`/LineOfBusiness/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error al obtener linea de negocio con id ${id}:`, error);
            throw error;
        }
    },

    createLineOfBusiness: async (lineOfBusinessData) => {
        try {
            const response = await ApiService.post('/LineOfBusiness', lineOfBusinessData);
            return response.data;
        } catch (error) {
            console.error('Error al crear linea de negocio:', error);
            throw error;
        }
    },

    editLineOfBusiness: async (id, lineOfBusinessData) => {
        try {
            lineOfBusinessData.id = id;
            const response = await ApiService.put(`/LineOfBusiness/${id}`, lineOfBusinessData);
            return response.data;
        } catch (error) {
            console.error('Error al editar linea de negocio:', error);
            throw error;
        }
    },

    deleteLineOfBusiness: async (id) => {
        try {
            const response = await ApiService.delete(`/LineOfBusiness/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error al desactivar:', error);
            throw error;
        }
    },


}

